var magicStyles = [".wrapper[data-v-1e340856]{display:grid;grid-template-columns:auto auto;gap:var(--magic-space,16px)}"];

export default magicStyles;
